import { Row, Col, PageHeader, Tag } from "antd";
import { getComponentList } from "Components/Report/OnDemand/chartsList/ChartsList";
import { AccountValues, accountOptions } from "../Filter";
import styles from "Components/Report/report.module.scss";
import { Fragment } from "react";
import { useAppSelector } from "store/hook";
import { useReportStatistic } from "Components/Report/queries";
import { PrintHeaderFooter } from "./PrintCover";

const AccountCharts = ({ parameter }: { parameter: AccountValues[] }) => {
  const { preference, filterForm } = useAppSelector((status) => status.report);
  const { loginCid, stateCid, level, isDarkMode } = useAppSelector((status) => status.global);

  const { data: reportStatistic, isLoading } = useReportStatistic(filterForm, loginCid, stateCid, level);
  const data = reportStatistic?.response?.account_level.status;
  const column = preference["column"]["account"] === 2 ? 12 : 24;
  const order = preference["order"]["account"];

  const orderedParameter = order.map((arr) => arr.filter((p) => parameter.includes(p)));
  const paraNumber = parameter.length;

  return (
    <Fragment>
      {
        <div
          className={styles.unPrint}
          style={{ padding: "12px", backgroundColor: isDarkMode ? "gray" : "#f5f5f5", marginTop: "1rem" }}
        >
          <PageHeader
            ghost={false}
            title="Account Level"
            subTitle={`Total: ${filterForm?.account_device?.length || 0} devices`}
          >
            {filterForm.account_parameter?.map((param, index) => {
              const option = accountOptions.find((opt) => opt.value === param);
              return <Tag key={index}>{option?.label}</Tag>;
            })}
          </PageHeader>
        </div>
      }
      <Row gutter={24}>
        {orderedParameter.map((col, ind) => (
          <Col sm={24} md={24} lg={column} xl={column} key={ind} className={styles.col}>
            <PrintHeaderFooter>
              {col.map((param, index) => {
                const newIndex = ind === 0 ? index : index + orderedParameter[0].length;

                return (
                  <Fragment key={newIndex}>
                    <div
                      key={index}
                      className={[
                        styles.elementHeight,
                        styles.noBreak,
                        newIndex % 2 === 1 ? styles.breakAfter : "",
                      ].join(" ")}
                    >
                      {
                        getComponentList({ param, data, isFetching: isLoading }).find((item) =>
                          item.value.includes(param)
                        )?.component
                      }

                      {Boolean(newIndex % 2 === 1) && (
                        <h2
                          className={[newIndex + 1 === paraNumber && paraNumber % 2 === 1 ? styles.h2Height : ""].join(
                            " "
                          )}
                        ></h2>
                      )}
                    </div>
                    {Boolean(newIndex + 1 === paraNumber && paraNumber % 2 === 1) && (
                      <div className={styles.elementHeight}>
                        <h2></h2>
                      </div>
                    )}
                  </Fragment>
                );
              })}
            </PrintHeaderFooter>
          </Col>
        ))}
      </Row>
      {/* <div className={styles.printOny}>
      {orderedParameter.reduce((acc,cur)=>[...acc,...cur],[]).reduce((acc,cur, index)=> {
        let lastElement= acc.slice(-1) 
        if(lastElement.length === 1 ) {
          //@ts-ignore
          lastElement = [...lastElement, ...cur]
          return [...acc.pop(), ]
        }
        return[...acc]
      } ,[]).map((col, ind) => (
          <Col sm={24} md={24} lg={column} xl={column} key={ind}>
            <PrintHeaderFooter>
              {col.map((param, index) => {
                const newIndex = ind === 0 ? index : index + orderedParameter[0].length;

                return (
                  <>
                    <div
                      key={index}
                      className={[
                        styles.elementHeight,
                        styles.noBreak,
                        newIndex % 2 === 1 ? styles.breakAfter : "",
                      ].join(" ")}
                    >
                      {
                        getComponentList({ param, data, isFetching: isLoading }).find((item) =>
                          item.value.includes(param)
                        )?.component
                      }

                      {Boolean(newIndex % 2 === 1) && (
                        <h2
                          className={[newIndex + 1 === paraNumber && paraNumber % 2 === 1 ? styles.h2Height : ""].join(
                            " "
                          )}
                        ></h2>
                      )}
                    </div>
                    {Boolean(newIndex + 1 === paraNumber && paraNumber % 2 === 1) && (
                      <div className={styles.elementHeight}>
                        <h2></h2>
                      </div>
                    )}
                  </>
                );
              })}
            </PrintHeaderFooter>
          </Col>
        ))}
      </div> */}
    </Fragment>
  );
};

export default AccountCharts;
